import FieldInput, { SCALAR_TYPES } from "src/libs/scalars";
import { CARD_FIELD_TYPE, ILandingCategory } from "src/modules/pe-landing-module/data/interfaces";
import {
  CardFieldButtons,
  CardFieldCanvas,
  CardFieldCategoryLabel,
  CardFieldCheckBox,
  CardFieldCroppedDivider,
  CardFieldDivider,
  CardFieldEmpty,
  CardFieldIcon,
  CardFieldImage,
  CardFieldInnerLink,
  CardFieldLogo,
  CardFieldMedallion,
  CardFieldOrder,
  CardFieldOuterLink,
  CardFieldPerson,
  CardFieldPersonalLinks,
  CardFieldPrice,
  CardFieldSection,
  CardFieldSpeechBubble,
  CardFieldStatisticLine,
  CardFieldTags,
  CardFieldTitle,
} from "../contentType/cardField";
import CardFieldHTML from "../contentType/cardField/CardFieldHTML";
import CardFieldTime from "../contentType/cardField/CardFieldTime";
import { ICardFieldProps } from "../contentType/cards/CardField";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";

/* Protopia Ecosystem component */
const FieldContent = (props: ICardFieldProps): JSX.Element => {
    const type = props.value.card_field_type || props.field.type
    if ( !type) return <></> 
    const landingCategory = getLandingCategory( type )      
    
    // console.log(props, landingCategory)  
    
    switch ( type ) {
        case CARD_FIELD_TYPE.BACKGROUND:
            return <></>;
        case CARD_FIELD_TYPE.EMPTY:
            return <CardFieldEmpty {...props} />;
        case CARD_FIELD_TYPE.CATEGORY_LABEL:
            return <CardFieldCategoryLabel {...props} />
        case CARD_FIELD_TYPE.LOGO:
            return <CardFieldLogo {...props} />;
        case CARD_FIELD_TYPE.ICON:
            return <CardFieldIcon {...props} />;
        case CARD_FIELD_TYPE.BUTTONS:
            return <CardFieldButtons {...props} />;
        case CARD_FIELD_TYPE.TITLE:
            return <CardFieldTitle {...props} />;
        case CARD_FIELD_TYPE.DIVIDER:
            return <CardFieldDivider {...props} />;
        case CARD_FIELD_TYPE.CROPPED_DIVIDER:
            return <CardFieldCroppedDivider {...props} />;
        case CARD_FIELD_TYPE.PRICE:
            return <CardFieldPrice {...props} />; 
        case CARD_FIELD_TYPE.MEDALLION:
            return <CardFieldMedallion {...props} />;
        case CARD_FIELD_TYPE.IMAGE: 
            return props.field.pseudonym === CARD_FIELD_TYPE.BACKGROUND 
                ? 
                <CardFieldEmpty {...props} />
                :
                <CardFieldImage {...props} />;
        case CARD_FIELD_TYPE.OUTER_LINK:
            return <CardFieldOuterLink {...props} />;
        case CARD_FIELD_TYPE.INNER_LINK:
            return <CardFieldInnerLink {...props} />;
        case CARD_FIELD_TYPE.PERSONAL_LINKS:
            return <CardFieldPersonalLinks {...props} />;
        case CARD_FIELD_TYPE.TAGS:
            return <CardFieldTags {...props} />;
        case CARD_FIELD_TYPE.CHECK_BOX:
            return <CardFieldCheckBox {...props} />;
        case CARD_FIELD_TYPE.STATISTIC_LINE:
            return <CardFieldStatisticLine {...props} />;
        case CARD_FIELD_TYPE.CANVAS:
            return <CardFieldCanvas {...props} />;
        case CARD_FIELD_TYPE.SPEECH_BUBBLE:
            return <CardFieldSpeechBubble {...props} />;
        case CARD_FIELD_TYPE.PERSON:
            return <CardFieldPerson {...props} />;
        case CARD_FIELD_TYPE.ORDER:
            return <CardFieldOrder {...props} />;
        case CARD_FIELD_TYPE.TIME:
            return <CardFieldTime {...props} />;
        case SCALAR_TYPES.HTML:
        case SCALAR_TYPES.TEXT: 
            return <CardFieldHTML {...props} />;
        case SCALAR_TYPES.STRING:
            return (
                <CFContainer
                {...{
                    ...props,
                    className:
                    (props.field?.className || "") +
                    " " +
                    " landing-card-field landing-card-field-string",
                }}
                >
                {props.value?.data}
                </CFContainer>
            );
        case SCALAR_TYPES.MEDIA:
            return (
                <CFContainer {...props}>
                    <FieldInput
                        rowClassName={"m-0"}
                        className={"m-0"}
                        type={props.field.type}
                        width="100%"
                        height={props.field.style?.height}
                        elementClassName="w-100 m-0"
                        value={props.value?.data}
                        editable={false}
                    />
                </CFContainer>
            );
        default:
            if (Object.values(SCALAR_TYPES).find((s) => s === props.field.type)) {
                return <CFContainer {...props}>
                    <FieldInput
                        rowClassName={"m-0"}
                        type={props.field.type}
                        elementClassName="text-center w-100 p-3"
                        value={props.value?.data}
                        editable={false}
                        style={{
                            textAlign: props.field.style?.textAlign,
                        }}
                    />
                </CFContainer> 
            } 
            console.log( props.field )
            
            if( !!landingCategory ) {                      
                return <CardFieldCategoryLabel {...props} />
            }
            return <></>;
    }
};
export default FieldContent;

export interface ICFContainerProps extends ICardFieldProps {
    children: JSX.Element;
}
const CFContainer = (props: ICFContainerProps): JSX.Element => {
    return (
        <div
            className={`landing-card-field landing-card-field-${props.field.type} ${
                props.field?.className || ""
            } ${props.value?.className || ""}`}
            style={{ ...props.field.style, ...props.value?.style }}
            data-card-field-id={props.i}
            data-card-field-section-id={props.section.id}
        >
            {props.children}
        </div>
    );
};


const getLandingCategory = (name: string ): ILandingCategory | undefined => {
    const currentLanding = useLandingStore.getState().currentLanding
    const landingCategories: ILandingCategory[] = currentLanding.categories || []
    const cat = landingCategories.find(ct => ct.id ===  name) || {} as ILandingCategory 
    // console.log( name, cat) 
    return cat
}